module.exports = __webpack_public_path__ + "static/Icons_homeloans_active_large-5e1eb00ddbd54b490c25df4e87e2cd1e.png";